<template>
  <div class="bg auth-screen">
    <div class="container pt-80  pb-50">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title">Create a New Password</h2>
          <form autocomplete="off">
            <div class="form-group otp-input-group">
              <label>Enter Code</label>
              <a @click="sendVerificationCode(true)" class="create-username" :class="{ disabled: apiCallInProgress }">Resend Code</a>
              <div class="row fpotp">
                <div class="col-lg-2">
                  <input type="text" v-validate="'required|digits:1'" name="otp_1" :class="{ input: true }" class=" form-control form-control-sm " v-model="otp_1" maxlength="1" id="otp_1" v-on:keyup="validatePassKey(1, $event)" v-on:paste="handleOtpPaste($event)" autocomplete="off" required tabindex="-1" />
                </div>
                <div class="col-lg-2">
                  <input type="text" v-validate="'required|digits:1'" name="otp_2" :class="{ input: true }" class="form-control form-control-sm " v-model="otp_2" maxlength="1" id="otp_2" v-on:keyup="validatePassKey(2, $event)" v-on:paste="handleOtpPaste($event)" autocomplete="off" required />
                </div>
                <div class="col-lg-2">
                  <input type="text" v-validate="'required|digits:1'" name="otp_3" :class="{ input: true }" class="form-control form-control-sm  " v-model="otp_3" maxlength="1" id="otp_3" v-on:keyup="validatePassKey(3, $event)" v-on:paste="handleOtpPaste($event)" autocomplete="off" required />
                </div>
                <div class="col-lg-2">
                  <input type="text" v-validate="'required|digits:1'" name="otp_4" :class="{ input: true }" class="form-control form-control-sm " v-model="otp_4" maxlength="1" id="otp_4" v-on:keyup="validatePassKey(4, $event)" v-on:paste="handleOtpPaste($event)" autocomplete="off" required />
                </div>
                <div class="col-lg-2">
                  <input type="text" v-validate="'required|digits:1'" name="otp_5" :class="{ input: true }" class="form-control form-control-sm " v-model="otp_5" maxlength="1" id="otp_5" v-on:keyup="validatePassKey(5, $event)" v-on:paste="handleOtpPaste($event)" autocomplete="off" required />
                </div>
                <div class="col-lg-2 mr-0">
                  <input type="text" v-validate="'required|digits:1'" name="otp_6" :class="{ input: true }" class="form-control form-control-sm " v-model="otp_6" maxlength="1" id="otp_6" v-on:keyup="validatePassKey(6, $event)" v-on:paste="handleOtpPaste($event)" autocomplete="off" required />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" class="form-control form-control-lg" @input="validPassword(user.password), validateConfirmPassword()" v-model="user.password" placeholder="Enter password" autocomplete="off" required id="password" />
            </div>
            <div class="form-group">
              <label for="confirm-password">Confirm Password</label>
              <input type="password" class="form-control form-control-lg" @input="validateConfirmPassword()" v-model="user.confirmPassword" placeholder="Re-enter password" required autocomplete="off" id="confirm-password" />
              <p class="text-danger" v-if="passwordNotMatched">
                Passwords do not match. Please try again.
              </p>
              <div class="regex-req">
                <div class="req-title">Password requirements:</div>
                <ul class="validation-list">
                  <li>
                    <span
                      v-if="passwordReq.showErrors"
                      :class="{
                        success: passwordReq.min8char,
                        error: !passwordReq.min8char
                      }"
                      aria-hidden="true"
                    ></span>
                    <span v-else class="initial-state" aria-hidden="true"></span>
                    Min. 8 characters
                  </li>
                  <li>
                    <span
                      v-if="passwordReq.showErrors"
                      :class="{
                        success: passwordReq.anyLetter,
                        error: !passwordReq.anyLetter
                      }"
                      aria-hidden="true"
                    ></span>
                    <span v-else class="initial-state" aria-hidden="true"></span>
                    at least 1 letter
                  </li>
                  <li>
                    <span
                      v-if="passwordReq.showErrors"
                      :class="{
                        success: passwordReq.number,
                        error: !passwordReq.number
                      }"
                      aria-hidden="true"
                    ></span>
                    <span v-else class="initial-state" aria-hidden="true"></span>
                    At least 1 number (12345)
                  </li>
                  <li>
                    <span
                      v-if="passwordReq.showErrors"
                      :class="{
                        success: passwordReq.specialChar,
                        error: !passwordReq.specialChar
                      }"
                      aria-hidden="true"
                    ></span>
                    <span v-else class="initial-state" aria-hidden="true"></span>
                    At least 1 symbol (!@#$%&)
                  </li>
                </ul>
              </div>
              <p class="text-danger mt-16" v-if="errorMsg">{{ errorMsg }}</p>
              <p class="text-success mt-16 text-center" v-if="isCodeResent">
                Code resent
              </p>
            </div>
            <div class="form-group mb-0">
              <button type="button" class="btn btn-primary btn-block" :disabled="disableSubmitBtn || errors.any() || apiCallInProgress" v-on:click.prevent="changePassword">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Auth } from "aws-amplify";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import localStorageService from "@/services/localStorage";
import otpInputMixin from "@/mixins/otpInputMixin";

export default {
  name: "CreatePassword",
  mixins: [otpInputMixin],
  data() {
    return {
      passwordNotMatched: false,
      disableSubmitBtn: true,
      user: {
        password: "",
        confirmPassword: "",
        code: "",
        username: this.$route.params.username
      },
      passwordReq: {
        min8char: false,
        /* 'uppercase': false,
                'lowercase': false, */
        anyLetter: false,
        number: false,
        specialChar: false,
        showErrors: false,
        passwordMatched: false
      },
      errorMsg: null,
      otp_1: "",
      otp_2: "",
      otp_3: "",
      otp_4: "",
      otp_5: "",
      otp_6: "",
      apiCallInProgress: false,
      isCodeResent: false,
      tokenToResetLockedAccount: null
    };
  },
  computed: {
    otpCombined() {
      return this.otp_1 + this.otp_2 + this.otp_3 + this.otp_4 + this.otp_5 + this.otp_6;
    }
  },
  watch: {
    apiCallInProgress(inProgress) {
      if (inProgress) {
        this.errorMsg = null;
        this.isCodeResent = false;
      }
    },
    otpCombined() {
      this.isCodeResent = false;
    }
  },
  mounted() {
    this.userLogout();
    //The Below code is for password change initiated by admins for portal users.
    if (this.$route.params.pwdChngInitByAdmin && this.$route.params.pwdChngInitByAdmin === "true") {
      this.sendVerificationCode(false);
    }
  },
  created() {
    //Get the token to Reset the attempts left or set the account lock status
    this.getTokenToResetLockStatus();
  },
  methods: {
    ...mapActions(["userLogout"]),
    async sendVerificationCode(isCodeResent) {
      this.apiCallInProgress = true;
      nprogress.start();
      try {
        const clientId = localStorageService.getItem("clientId");
        await Auth.forgotPassword(this.user.username.toLowerCase(), {
          userType: "portal",
          requestFor: "FORGOT_PASSWORD",
          clientId: clientId,
          requestFrom: "web"
        });
        this.apiCallInProgress = false;
        this.isCodeResent = isCodeResent;
        nprogress.done();
      } catch (error) {
        this.apiCallInProgress = false;
        nprogress.done();
        if (error.code && error.code == "UserNotFoundException") {
          this.errorMsg = "Username not found.";
        } else {
          this.errorMsg = error.message;
        }
      }
    },
    async changePassword() {
      this.apiCallInProgress = true;
      nprogress.start();
      try {
        this.user.code = this.otpCombined;
        const requestBody = {
          username: this.user.username.toLowerCase(),
          newPassword: this.user.password,
          confirmationCode: this.user.code
        };
        const response = await this.$api.ResetUserPassword(requestBody);
        if (this.tokenToResetLockedAccount) {
          //Update the lock status
          await this.$api.updateLockedStatus({
            username: this.user.username,
            token: this.tokenToResetLockedAccount
          });
          this.$router.push({
            name: "login"
          });
        } else {
          this.$router.push({
            name: "login"
          });
        }
      } catch (error) {
        this.apiCallInProgress = false;
        nprogress.done();
        if (error.body && error.body.errorMessage) {
          this.errorMsg = error.body.errorMessage;
        } else {
          this.errorMsg = error;
        }
      }
    },
    validateConfirmPassword() {
      this.disableSubmitBtn = true;
      this.passwordNotMatched = false;
      this.passwordReq.passwordMatched = false;
      if (this.user.password === this.user.confirmPassword && this.passwordReq.min8char && this.passwordReq.anyLetter && this.passwordReq.number && this.passwordReq.specialChar) {
        this.passwordNotMatched = false;
        this.disableSubmitBtn = false;
        this.passwordReq.passwordMatched = true;
      } else if (this.user.confirmPassword === "") {
        this.passwordNotMatched = false;
      } else if (this.user.password === this.user.confirmPassword) {
        this.passwordNotMatched = false;
        this.passwordReq.passwordMatched = true;
      } else {
        this.passwordNotMatched = true;
      }
    },
    validPassword(password) {
      this.disableSubmitBtn = true;
      this.passwordReq.showErrors = true;
      const numberPattern = new RegExp("^(?=.*[0-9]).+$");
      const specialPattern = new RegExp("^(?=.*[!\"@#$%&'(\)*+,-./:;<=>?\[\\\]^_{|}~]).+$");
      const letterPattern = new RegExp("^(?=.*[a-zA-Z]).+$");

      // empty password check
      if (password === "") {
        this.passwordReq.showErrors = false;
      } else if (password.length >= 8) {
        this.passwordReq.min8char = true;
      } else if (password.length < 8) {
        this.passwordReq.min8char = false;
      }

      // any letter pattern check
      if (letterPattern.test(password)) {
        this.passwordReq.anyLetter = true;
      } else {
        this.passwordReq.anyLetter = false;
      }

      //Atleast 1 number
      if (numberPattern.test(password)) {
        this.passwordReq.number = true;
      } else {
        this.passwordReq.number = false;
      }

      //Atleast 1 special char
      if (specialPattern.test(password)) {
        this.passwordReq.specialChar = true;
      } else {
        this.passwordReq.specialChar = false;
      }
    },
    getTokenToResetLockStatus() {
      this.$api
        .resetLoginAttemptNLockStatus({
          username: this.user.username
        })
        .then(
          response => {
            this.tokenToResetLockedAccount = response.body.message;
          },
          error => {
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while getting token to reset locked status";
          }
        );
    }
  }
};
</script>
<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
